export const SubMenuInvestment = [
  {
    name: "Mineral Potential of Pakistan",
    link: "/mineral-potential",
  },
  {
    name: "Investment Opportunities",
    link: "/investment-opportunities",
  },
  {
    name: "Fiscal Incentives",
    link: "/fiscal-incentives",
  },
  {
    name: "Mineral Development Strategy",
    link: "/mineral-development-strategy",
  },
  {
    name: "Special Investment Facilitation Council (SIFC)",
    link: "/special-investment-facilities",
  },
  {
    name: "Applying for Mineral Title",
    link: "/applying-for-mineral-title",
  },
  {
    name: "Development Initiatives",
    link: "/development-initiatives",
  },
  {
    name: "Starting New Business",
    link: "/starting-new-business",
  },
];

export const SubMenuMapsAndReports = [
  {
    name: "GIS Portal",
    link: "/gis-portal",
  },
  {
    name: "Geological Data",
    link: "/access-to-geological-data",
  },
];

export const SubMenuExpartriateSecurity = [
  {
    name: "NOC Sponsor Company",
    link: "/noc-sponsor-company",
  },
  {
    name: "Expat NOC Application",
    link: "/expact-noc-application",
  },
];

export const SubMenuMineralTestingLabs = [
  {
    name: "Tests Information",
    link: "/test-information",
  },
  {
    name: "Applying for Mineral Test",
    link: "/applying-for-mineral-test",
  },
  {
    name: "View Results",
    link: "/minerals-test-results",
  },
];

export const SubMenuResearchAndDevelopment = [];

export const SubMenuFiscal = [
  {
    name: "Taxes Structure",
    link: "/fiscal-regime-tax",
  },
  {
    name: "Royalty Fee",
    link: "/royalty-fee",
  },
  {
    name: "Cess & Levy",
    link: "/cess",
  },
];

export const SubMenuStatistics = [
  {
    name: "Revenue Collection",
    link: "/statistics-revenue",
  },
  {
    name: "Employement",
    link: "/statistics-employement",
  },
  {
    name: "Production Data",
    link: "/statistics-production",
  },
  {
    name: "Import & Export Stats",
    link: "/statistics-ie",
  },
  {
    name: "Accident & Rescue",
    link: "/statistics-incidents",
  },
];

export const SubMenuGovernance = [
  {
    name: "Institutional Arrangement",
    link: "/institutional-arrangement",
  },
  {
    name: "Policies",
    link: "/legal-policies",
  },
];

export const SubMenuActsAndLaws = [
  {
    name: "Mining Operations",
    link: "/mining-operations",
  },
  {
    name: "Health & Safety",
    link: "/health-safety",
  },
];

export const SubMenuRulesAndRegulations = [
  {
    name: "Concession Rules",
    link: "/consession-rules",
  },
  {
    name: "Labor Welfare",
    link: "/labor-welfare",
  },
];

export const SubMenuIntiatives = [
  {
    name: "Major Mining Projects",
    link: "/major-mining",
  },
  {
    name: "Training & Skill Development",
    link: "/training-skill",
  },
];

export const SubMenuWhoIsWho = [
  {
    name: "Government Departments",
    link: "/government-departments",
  },
  {
    name: "Mining Professional",
    link: "/mining-professional",
  },
  {
    name: "Geotechnical Geophysical Geological Services",
    link: "/geotechnical-geophysical-services",
  },
  {
    name:"Drilling Companies",
    link: "/drilling-companies",
  },
  {
    name:"Mining Companies",
    link: "/mining-companies",
  },
  {
    name:"Mineral Based Industries",
    link: "/mineral-based-industries",
  },
  {
    name:"Machinery suppliers",
    link: "/machinery-suppliers",
  },
  {
    name:"Mineral Testing Labs",
    link: "/mineral-labs",
  },
  {
    name:"Explosive Suppliers",
    link: "/explosive-suppliers",
  },
  {
    name:"Software and Solutions Entities",
    link: "/software-solution-entities",
  },
  {
    name:"Legal Services",
    link: "/legal-services",
  },
  {
    name:"Audit & Accounts",
    link: "/audit-accounts",
  },
  {
    name:"Land Surveying",
    link: "/land-surveying",
  },
  {
    name: "Academia And RD",
    link: "/academia",
  },
  {
    name: "Training Schools",
    link: "/training-schools",
  },
  {
    name:"Other Services",
    link: "/other-services",
  },
  {
    name:"Apply For Registration",
    link: "/registerorganization",
  }
];

export const SubMenuCSR = [
  {
    name: "CSR Regulations",
    link: "/csr-regulations",
  },
  {
    name: "Success Stories",
    link: "/csr-success-stories",
  },
  {
    name: "CSR Initiatives",
    link: "/csr-initiatives",
  },
  {
    name: "Voice of Community",
    link: "/csr-community",
  },
];
